<template>
    <div class="balance-user">
        <div class="index-view-top">
            <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
            <div class="title">{{ $t("vip.ckgz") }}</div>
            <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
        </div>
        <div v-html="article" style="padding:0 15px">

        </div>
    </div>
</template>

<script>

import { article } from '@/utils/request'
export default {
    data() {
        return {
            article: ''
        };
    },
    mounted() {
        this.contactInfo()
    },
    methods: {
        contactInfo() {
            article({ type: this.$route.query.type }).then(res => {
                if (res.code == '200') {
                    this.article = res.data.content
                }
            })
        },
        toBack() {
            this.$router.go("-1");
        },
    },
};
</script>

<style lang="scss" scoped>
.balance-user {
    width: 100vw;
    min-height: 100vh;
    background: #0c0b0b;

    /deep/ p {
        color: #ffffff;
    }

    .index-view-top {
        height: 3.625rem;
        padding: 0 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 1.125rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/spread/rules.vue